/*
  Zenino: prima pagina. Raioanele de produse (sageti, pastila de derulare), filele "Populare pe categorii",
  "Vazute recent" si "Recomandate pentru tine" (dupa ultimul produs vazut). Filele se incarca la deschidere.
  Se incarca din mai multe sectiuni: ruleaza o data.
*/
(() => {
  if (window.znHome) return;
  window.znHome = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRail(rail) {
    if (rail.znUpdate) {
      rail.znUpdate();
      return;
    }
    const track = rail.querySelector('.zn-rail__track');
    const prev = rail.querySelector('[data-zn-prev]');
    const next = rail.querySelector('[data-zn-next]');
    const bar = rail.querySelector('.zn-rail__bar');
    const thumb = bar && bar.querySelector('.zn-rail__thumb');
    if (!track) return;
    let frame = 0;

    const update = () => {
      frame = 0;
      if (!track.clientWidth) return; // fila ascunsa
      const max = track.scrollWidth - track.clientWidth;
      const overflow = max > 2;
      if (prev) prev.hidden = !overflow;
      if (next) next.hidden = !overflow;
      if (bar) bar.hidden = !overflow;
      if (!overflow) return;

      const x = Math.min(Math.max(track.scrollLeft, 0), max);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;

      if (thumb) {
        const bw = bar.clientWidth;
        const tw = Math.max(Math.round(bw * (track.clientWidth / track.scrollWidth)), 28);
        thumb.style.width = `${tw}px`;
        thumb.style.transform = `translateX(${Math.round((bw - tw) * (x / max))}px)`;
      }

      const media = track.querySelector('.card__media');
      if (media) {
        const top = media.getBoundingClientRect().top - rail.getBoundingClientRect().top;
        rail.style.setProperty('--zn-arrow-y', `${Math.round(top + media.offsetHeight / 2)}px`);
      }
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    const page = (dir) => {
      const item = track.querySelector('.zn-rail__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      const count = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      track.scrollBy({ left: dir * count * step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => page(-1));
    if (next) next.addEventListener('click', () => page(1));
    track.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    else window.addEventListener('resize', schedule);

    rail.znUpdate = schedule;
    update();
  }

  function initTabs(root) {
    if (root.znTabs) return;
    root.znTabs = true;
    const tabs = Array.from(root.querySelectorAll('[data-zn-tab]'));
    const list = root.querySelector('.zn-tabs__list');

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        const link = root.querySelector(`[data-zn-tab-link="${t.dataset.znTab}"]`);
        if (link) link.hidden = !on;
      });
      if (focus) tab.focus({ preventScroll: true });

      // fila aleasa ramane vizibila in randul de file, fara sa miste pagina
      if (list) {
        const left = tab.offsetLeft;
        const right = left + tab.offsetWidth;
        if (left < list.scrollLeft || right > list.scrollLeft + list.clientWidth) {
          list.scrollTo({ left: Math.max(left - 24, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      }

      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) {
        panel.querySelectorAll('[data-zn-rail]').forEach(initRail);
        loadPanel(panel);
      }
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      // fila se cere deja cand mouse-ul sau degetul ajunge pe ea, ca sa fie gata la clic
      const warm = () => {
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) fetchPanel(panel);
      };
      tab.addEventListener('pointerenter', warm, { passive: true });
      tab.addEventListener('touchstart', warm, { passive: true });
      tab.addEventListener('focus', warm);
      tab.addEventListener('keydown', (e) => {
        let j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) {
          e.preventDefault();
          select(tabs[j], true);
        }
      });
    });
  }

  // Filele "Populare pe categorii" in afara de prima vin de la templates/collection.zn-rail.liquid.
  function fetchPanel(panel) {
    if (!panel.dataset.znSrc) return null;
    if (!panel.znRequest) {
      panel.znRequest = fetch(panel.dataset.znSrc)
        .then((res) => (res.ok ? res.text() : ''))
        .catch(() => '');
    }
    return panel.znRequest;
  }

  async function loadPanel(panel) {
    if (panel.znLoaded || !panel.dataset.znSrc) return;
    panel.znLoaded = true;
    panel.setAttribute('aria-busy', 'true');
    const html = await fetchPanel(panel);
    const rail = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zn-rail]');
    panel.removeAttribute('aria-busy');
    if (!rail) {
      // fara raspuns, fila duce macar la colectie
      panel.znLoaded = false;
      panel.znRequest = null;
      return;
    }
    const node = document.importNode(rail, true);
    dedupeRail(node);
    panel.replaceChildren(node);
    if (typeof window.initLazyImages === 'function') window.initLazyImages();
    if (!panel.hidden) initRail(node);
  }

  function viewedIds() {
    try {
      const ids = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  async function loadReco(root) {
    if (root.znReco) return;
    root.znReco = true;
    const ids = viewedIds();
    if (!ids.length) return;
    try {
      const res = await fetch(`${root.dataset.znReco}&product_id=${encodeURIComponent(ids[0])}`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const rail = doc.querySelector('[data-zn-rail]');
      if (!rail) return;
      // produsele deja vazute sunt in "Vizitate recent"; aici raman doar cele noi pentru vizitator
      rail.querySelectorAll('.zn-rail__item').forEach((item) => {
        const el = item.querySelector('[data-product-id]');
        if (el && ids.includes(el.dataset.productId)) item.remove();
      });
      if (rail.querySelectorAll('.zn-rail__item').length < 3) return;
      const slot = root.querySelector('.zn-reco__slot');
      slot.replaceChildren(document.importNode(rail, true));
      root.hidden = false;
      if (typeof window.initLazyImages === 'function') window.initLazyImages();
      slot.querySelectorAll('[data-zn-rail]').forEach(initRail);
    } catch (e) {
      // fara recomandari, sectiunea ramane ascunsa
    }
  }

  async function loadRecent(root) {
    if (root.znRecent) return;
    root.znRecent = true;
    const ids = viewedIds().slice(0, Number(root.dataset.limit) || 12);
    if (!ids.length) return;
    try {
      const q = ids.map((id) => `id:${id}`).join(' OR ');
      const res = await fetch(`${root.dataset.znRecent}${encodeURIComponent(q)}`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const rail = doc.querySelector('[data-zn-rail]');
      if (!rail) return;
      // cautarea le ordoneaza dupa relevanta; aici raman in ordinea in care au fost vazute
      const track = rail.querySelector('.zn-rail__track');
      const items = Array.from(track.querySelectorAll('.zn-rail__item'));
      const pos = (item) => {
        const el = item.querySelector('[data-product-id]');
        const i = el ? ids.indexOf(el.dataset.productId) : -1;
        return i < 0 ? ids.length : i;
      };
      items.sort((a, b) => pos(a) - pos(b)).forEach((item) => track.appendChild(item));
      const slot = root.querySelector('.zn-reco__slot');
      slot.replaceChildren(document.importNode(rail, true));
      root.hidden = false;
      if (typeof window.initLazyImages === 'function') window.initLazyImages();
      slot.querySelectorAll('[data-zn-rail]').forEach(initRail);
    } catch (e) {
      // fara produse vazute, sectiunea ramane ascunsa
    }
  }

  // Acelasi produs nu se repeta in raioanele de mai jos: cardurile de categorie si raioanele marcate
  // inregistreaza ce arata, iar raioanele de dedesubt il scot (raman cel putin 5), apoi se taie la data-max.
  const productPath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
    } catch (e) {
      return '';
    }
  };

  const seen = new Set();
  const railKey = (item) => {
    const link = item.querySelector('.card-link, a[href*="/products/"]');
    return link ? productPath(link.getAttribute('href')) : '';
  };

  function dedupeRail(rail) {
    const mode = rail.dataset.znDedupe;
    if (!mode) return;
    const items = Array.from(rail.querySelectorAll('.zn-rail__item'));
    let kept = items;
    if (mode !== 'register') {
      const fresh = items.filter((item) => !seen.has(railKey(item)));
      if (fresh.length >= 5) {
        items.filter((item) => !fresh.includes(item)).forEach((item) => item.remove());
        kept = fresh;
      }
    }
    const max = Number(rail.dataset.max) || 0;
    if (max && kept.length > max) {
      kept.slice(max).forEach((item) => item.remove());
      kept = kept.slice(0, max);
    }
    if (mode !== 'skip') kept.forEach((item) => seen.add(railKey(item)));
  }

  function dedupe(scope) {
    scope.querySelectorAll('.zn-quad__item').forEach((a) => seen.add(productPath(a.getAttribute('href'))));
    scope.querySelectorAll('[data-zn-dedupe]').forEach(dedupeRail);
  }

  function init(scope) {
    dedupe(scope);
    scope.querySelectorAll('[data-zn-rail]').forEach((rail) => {
      if (!rail.closest('[hidden]')) initRail(rail);
    });
    scope.querySelectorAll('[data-zn-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-zn-recent]').forEach((root) => loadRecent(root));
    scope.querySelectorAll('[data-zn-reco]').forEach((root) => {
      if (typeof window.initLazyScript === 'function') window.initLazyScript(root.parentElement || root, () => loadReco(root), 600);
      else loadReco(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
